/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ValidationMessage,
    ValidationMessageFromJSON,
    ValidationMessageFromJSONTyped,
    ValidationMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface ListItemValidationMessage
 */
export interface ListItemValidationMessage {
    /**
     * 
     * @type {number}
     * @memberof ListItemValidationMessage
     */
    index?: number;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof ListItemValidationMessage
     */
    message?: ValidationMessage;
}

export function ListItemValidationMessageFromJSON(json: any): ListItemValidationMessage {
    return ListItemValidationMessageFromJSONTyped(json, false);
}

export function ListItemValidationMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListItemValidationMessage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'index': !exists(json, 'index') ? undefined : json['index'],
        'message': !exists(json, 'message') ? undefined : ValidationMessageFromJSON(json['message']),
    };
}

export function ListItemValidationMessageToJSON(value?: ListItemValidationMessage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'index': value.index,
        'message': ValidationMessageToJSON(value.message),
    };
}


